import React, { forwardRef } from "react";
import cn from "classnames";
import styles from "./index.module.scss";

const CalcFormInput = forwardRef((props, ref) => {
  const { showTrashButton, onRemoveInputClick, error, ...rest } = props;

  return (
    <div className={cn(styles.wrapper, error && styles.fieldError)}>
      <input
        ref={ref}
        {...rest}
        onWheel={(e) => {
          e.currentTarget.blur();
        }}
      />
      {showTrashButton && (
        <button
          className={styles.button}
          type="button"
          onClick={onRemoveInputClick}
        >
          <img width="16" height="16" src="/svgs/icons/trash.svg" alt="alt" />
        </button>
      )}
    </div>
  );
});

export default CalcFormInput;
